export const getBadgeStatus = (status: string | undefined | null): string => {
  if (!status) return 'neutral';

  // Normalize the status by trimming whitespace and converting to lowercase
  const normalizedStatus = status.toString().trim().toLowerCase();

  // Success states
  const successStates = [
    'new', 'active', 'success', 'completed', 'verified',
    'updated', 'delivered', 'succeeded', 'paid',
    'running', 'up to date', 'uptodate', 'up-to-date',
    'healthy', 'enabled', 'installed', 'approved', 'production',
    'submitted', 'accepted', 'won', 'awarded', 'finalized',
    'closed', 'finished', 'done', 'confirmed', 'valid',
    'published', 'live', 'operational', 'available', 'gem',
  ];

  // Warning states
  const warningStates = [
    'pending', 'warning', 'processing',
    'queued', 'scheduled', 'waiting',
    'staging', 'draft', 'under review',
    'price-review', 'criteria-review', 'review',
    'in-progress', 'progress', 'ongoing',
    'delayed', 'extended', 'renegotiation',
    'tentative', 'conditional', 'provisional'
  ];

  // Danger states
  const dangerStates = [
    'failed', 'expired', 'inactive',
    'danger', 'stopped', 'outdated',
    'error', 'rejected', 'disabled',
    'suspended', 'unhealthy', 'missing',
    'cancelled', 'terminated', 'void',
    'lost', 'declined', 'withdrawn',
    'disqualified', 'blacklisted', 'blocked',
    'overdue', 'lapsed', 'unpaid', 'duplicate',
    'not-bidded'
  ];

  // Neutral states
  const neutralStates = [
    'shutdown', 'no need',
    'skipped', 'neutral',
    'n/a', 'not applicable', 'na',
    'unknown', 'undefined', 'null',
    'none', 'blank', 'empty',
    'not set', 'to be determined', 'tbd', 'price-review', 'criteria-review', 'watchlist'
  ];

  // Info states
  const infoStates = [
    'read', 'info',
    'in progress', 'syncing',
    'pending review', 'development',
    'allocated', 'distributed',
    'monitoring', 'tracking', 'observing',
    'documented', 'recorded', 'logged',
    'notified', 'alerted', 'informed',
    'shared', 'distributed', 'circulated',
    'bid', 'tendered', 'offered',
    'shortlisted', 'pre-qualified', 'qualified',
    'evaluating', 'assessing', 'scoring', 'non-gem', 'assigned-to-engineer', 'assigned-to-agent'
  ];

  // Check status against all categories
  if (successStates.some(s => normalizedStatus === s)) {
    return 'success';
  }
  if (warningStates.some(s => normalizedStatus === s)) {
    return 'warning';
  }
  if (dangerStates.some(s => normalizedStatus === s)) {
    return 'danger';
  }
  if (neutralStates.some(s => normalizedStatus === s)) {
    return 'neutral';
  }
  if (infoStates.some(s => normalizedStatus === s)) {
    return 'info';
  }

  // Default to neutral if no match found
  return 'neutral';
};

export const WORKFLOW_STATUS_LABELS: Record<string, string> = {
  'assigned-to-agent': 'Assigned',
  'price-review': 'Price Review',
  'criteria-review': 'Criteria Review',
  'ready-to-bid': 'Ready to Bid',
  'submitted': 'Submitted',
  'completed': 'Completed',
  'assigned-to-engineer': 'Assigned to engg',
  'in-progress': 'In Progress',
  'new': 'New',
  'not-fit': 'Not Fit',
  'not-bidded': 'Not Bidded',
  'won': 'Won',
  'lost': 'Lost',
};

// Role-based status filters
export const TENDER_STATUSES = [
  'assigned-to-agent',
  'price-review',
  'criteria-review',
  'ready-to-bid',
  'submitted',
  'completed',
  'assigned-to-engineer',
  'in-progress',
  'new',
  'not-fit',
  'not-bidded',
  'won',
  'lost',
];

export const getWorkflowLabel = (status: string | undefined): string => {
  if (!status) return 'Unknown';
  return WORKFLOW_STATUS_LABELS[status] ||
         status.replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
};
